import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { Subscription } from 'rxjs';

import { ChangeDetectorRef, OnDestroy } from '@angular/core';
import { filter } from 'rxjs/operators';
import { UiAction, UiHelperService } from '../ui-helper.service';
import { SvgHelperComponent } from '../svg-helper/svg-helper.component';
import { PublishProgressComponent } from '../publish-progress/publish-progress.component';

@Component({
  selector: 'accordion-form',
  templateUrl: './accordion-form.component.html',
  styleUrls: ['./accordion-form.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgClass, SvgHelperComponent, PublishProgressComponent]
})
export class AccordionFormComponent implements OnInit, OnDestroy {
  private uiHelper = inject(UiHelperService);
  private cdf = inject(ChangeDetectorRef);

  @Input() allowDuplicate = true;
  @Input() allowSave = false;
  @Input() allowPublish = false;
  @Input() allowEditRequest = false;
  @Input() allowDelete = true;
  @Input() closedOnInit = false;
  @Input() isDirty = false;
  @Input() isInvalid = false;
  @Input() internalNames: string[];
  @Input() publishing = false;
  @Output() publish = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() duplicateAndAdd = new EventEmitter();
  @Output() requestEdit = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() open = new EventEmitter();
  isOpen = true;
  sub: Subscription;
  hasOpenedOnce = false;

  ngOnInit() {
    this.isOpen = !this.closedOnInit;
    this.hasOpenedOnce = this.isOpen;

    if (this.internalNames?.length) {
      this.sub = this.uiHelper.messages$
        .pipe(filter(message => this.internalNames.includes(message.Name)))
        .subscribe(message => {
          if (message.Action === UiAction.Open && !this.isOpen) {
            this.toggle();
            this.cdf.markForCheck();
          }
        });
    }
  }

  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
  }

  toggle() {
    this.isOpen = !this.isOpen;

    if (this.isOpen) {
      this.open.emit();
      this.hasOpenedOnce = true;
    }
  }

  doDuplicate(evt: Event) {
    evt.stopPropagation();
    this.isOpen = false;
    this.duplicateAndAdd.emit();
  }

  handleSave(evt: Event) {
    evt.stopPropagation();
    this.save.emit();
  }

  handlePublish(evt: Event) {
    evt.stopPropagation();
    this.publish.emit();
  }
}
